class Constants {
    static noValue = "——";

    static userInfoKey = {
        USERNAME: "UserName",
        SPEEDBOAT: "speedboat",
        EMAIL: "email",
        ACCOUNTNUMBER: "accountNumber",
        ACCOUNTNAME: "accountName",
        ROLES: "roles",
        SPEEDBOATNAME: "speedboatName",
        SALESORG: "salesOrg",
        ORDERBLOCK: "orderBlock",
    }
    static defaultAlertTabList = {
        PCN: {
            name: 'PCN',
            alias: 'PCN'
        },
        EOL: {
            name: 'EOL',
            alias: 'EOL'
        },
        Stock: {
            name: "Stock alerts",
            alias: 'Stock'
        }
    }
    static alertTypes = {
        PCN: "PCN",
        EOL: "EOL",
        STOCK_ALERT: "Stock",
    }
    static systemModules = {
        PDP: "PDP",
        PLP: "PLP",
        Quote: "QUOTE",
        BOM: "BOM",
        CART: "Cart",
        CHECKOUT: "CheckOut"
    }
    static cpnTypes = {
        CPN: "CPN",
        MANUALCPN: "ManualCPN",
    }

    static cartSummary = {
        SUBTOTAL: "subTotal",
        ORDERTOTAL: "orderTotal",
    }

    static addressType = {
        BILL_TO: "BillTo",
        SHIP_TO: "ShipTo",
    }

    static validateQtyMsg = "Please provide different quantity values."
    static downloadMsg = "The document successfully downloaded. Please check your computer or new browser window for the document.";
    static emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    static ForecastPreferenceType = 'Download_Forecast_FileType'
    static internalUsers = ["ebv.com", "avnet.eu", "silica.com", "avnet-abacus.eu", "abacus.co.uk",
        "avnet-embedded.eu", "avnet.com", "AVNETTIME.EU", "avnet-memec.eu", "avnet.abacus.eu"]

    static speedBoatList = [
        { value: 'T', label: 'ABACUS' },
        { value: 'S', label: 'SILICA' },
        { value: 'B', label: 'EBV' }
    ]
    static adminConsoleTab = {
        User: "users",
        Account: "accounts",
        Report: "reports",
    }
    static roles = [
        { value: 'ZI', label: 'ZI' },
        { value: 'ZX', label: 'ZX' },
        { value: 'ZU', label: 'ZU' }
    ]
    static siteUser = {
        GUEST: "Guest",
        WEB: "Web",
        CORE: "Core"
    }
    static userType = {
        INTERNAL: 'Internal',
        EXTERNAL: 'External'
    }
    static errorCode = "UserExist001"

    static MYAVNET = {
        ABACUS: 'MyAvnetAbacus',
        SILICA: 'MyAvnetSilica',
        EBV: 'MyEBV'
    }
    static orderPayload = {
        Buyer: 'Buyer',
        CustomerPartNo: 'CustPartNumber',
        ManufacturerPartNo: 'MfrPartNumber',
        OrderNumber: 'OrderNumber',
        OrderType: 'OrderType',
        PONumber: 'PoNumber',
        POLineItemNumber: 'POlineItemNumber'
    }

    static product__ROHSCompliantCode = {
        "Y": "RoHS 6 Compliant",
        "X": "RoHS 6 Exempt",
        "N": "RoHS Non Complaint",
        "U": "UNDETERMINED",
        "C": "RoHS 10 Compliant",
        "E": "RoHS 10 Exempt",
    }

    static sourceOfBOM = {
        PDP: "pdp",
        PLP: "plp",
        SEARCH: "search",
        UPLOAD: "upload",
        DESIGNHUB: "designhub",
        BOMCOMPARE: "bomcompare",
        PARTLIST: "partlist",
        AVAIL: "avail",
        BOMLIST: "bomlist"
    }
    static FactoryLeadTime = [undefined, null, '', 0, '0', 999, '999'];

    static isFrom = {
        PLP: "PLP",
        PDP: "PDP",
        COMPARE: "COMPARE",
        BOM_EXACT_MATCH: "BOM_EXACT_MATCH",
        BOM_ALT_POPUP: "BOM_ALT_POPUP",
        CART_LIST: "CART_LIST",
        PDP_ALT: "PDP_ALT",
        OPEN_QUOTE: "OPEN_QUOTE",
        QUOTE_DETAIL: "QUOTE_DETAIL",
    }

    static speedBoats = {
        abacusAbbr: 'T',
        ABACUS: 'Abacus',
        abacus: 'abacus',
        ebvAbbr: 'B',
        EBV: 'EBV',
        silicaAbbr: 'S',
        SILICA: 'Silica'
    }

    static analyticsEvent = {
        ADD_FARNELL_ITEM: 'addItemsToFarnell'
    }
    static homePageAllTabs = {
        PRODUCT: {
            tabHeader: "Products",
            countTab: "productCount",
            abbr: "PLT"
        },
        NPI: {
            tabHeader: "New Product Information",
            contentType: 'NPI',
            content: "NPI",
            countTab: "npiCount",
            abbr: "NPIT"
        },
        CONTENT: {
            tabHeader: "Content",
            countTab: "allContentCount",
            abbr: "CNT"
        },
        ALLCONTENT: {
            tabHeader: "All Content",
            contentType: 'All',
            content: "AllContent",
            countTab: "allCount",
            abbr: "ALCT"
        },
        ARTICLE: {
            tabHeader: "Articles",
            contentType: 'articles',
            content: "Articles",
            countTab: "articleCount",
            abbr: "ACL"
        },
        EVENT: {
            tabHeader: "Events",
            contentType: 'events',
            content: "Events",
            countTab: "eventCount",
            abbr: "EVT"
        },
        SITE: {
            tabHeader: "Site pages",
            contentType: 'sitePages',
            content: "SitePage",
            countTab: "siteCount",
            abbr: "SITE"
        },
        VIDEO: {
            tabHeader: "Videos",
            contentType: 'video',
            countTab: "videoCount",
            abbr: "VDO",
            pageType: "Brightcove-Videos"
        },
        DOCUMENT: {
            tabHeader: "Documents",
            countTab: "documentCount",
            abbr: "DCT"
        },
        OTHER: {
            tabHeader: "Other",
            contentType: 'other',
            content: "Other",
            countTab: "otherCount",
            abbr: "OTR"
        }
    };
}
export default Constants;